import React, {useEffect} from "react";
import JPMorgan from "src/assets/JPMorgan.svg";
import Payments from "src/assets/Payments.svg";
import {Link} from "@salt-ds/core";
import { useDispatch } from "react-redux";
import { setShowHeaderFlag } from "src/reducers/slices/SetSecDataSlice";

const AchHeader: React.FC = () => {
    const dispatch = useDispatch();


    useEffect(() => {
        dispatch(setShowHeaderFlag(false));

    }, []);

    return (
        <>
            <header
                className="sticky w-full top-0  h-[82px]  bg-white shadow flex-col  inline-flex z-50"
            >
                <div

                    className="mx-auto my-[20px]  w-[683px] h-8 justify-center items-center inline-flex "
                >
                </div>
                <div className="ml-[24px] absolute my-[25px]  w-[273px] gap-[16.58px] h-11 justify-start items-start inline-flex ">
                    <div className="w-[161.08px] h-8 relative">
                        <img src={JPMorgan} alt="JPMorgan" />
                    </div>
                    <div className="w-[69.86px] my-auto h-[10.62px] relative">
                        <img src={Payments} alt="Payments" />
                    </div>
                </div>
                {/*<Button className=" w-[170px] h-8 px-2 py-[7px] bg-cyan-700 rounded ml-8 normal-case" variant="cta" onClick={handleSkipClick}>Skip to Main Content</Button>*/}
                <Link href="#mainContent" style={{textDecoration: 'underline'}}
                      className="absolute mb-[57px] mt-[62px] ml-[24px] left-[-999px] top-0 focus:left-0 focus:top-0 focus:z-50 underline-offset-1 focus:text-skipLink p-2 "
                >
                    Skip to Main Content
                </Link>
                <div className="mx-auto my-[29px]  h-8 pr-[0.01px] justify-center items-center gap-[16.58px] inline-flex  ">
                </div>

            </header>
        </>
    );
};
export default AchHeader;
